var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-design-map",attrs:{"id":"flow-design-map"}},[_c('img',{attrs:{"src":_vm.$storeProcess.state.flow.mapImg}}),_vm._v(" "),_c('div',{staticClass:"map-mask",style:(_vm.mapMask),attrs:{"id":"flow-design-map-mask"},on:{"mousedown":_vm.handleMouseDown,"mouseup":_vm.handleMouseUp,"mouseleave":_vm.handleMouseUp}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef061ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/packages/Common/FlowMap.vue
// module id = null
// module chunks = 